import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Header from './header';
import Footer from './footer';
import {
  FaShieldAlt,
  FaUserShield,
  FaLock,
  FaCookieBite,
  FaCreditCard,
  FaSyncAlt,
  FaEnvelope,
} from 'react-icons/fa';

const PrivacyPolicy = () => {
  return (
    <div
      id="privacy-policy"
      className="privacy-page"
    >
      <Header />

      {/* Hero / Page Header */}
      <section className="privacy-hero">
        <Container>
          <Row className="justify-content-center">
            <Col lg={9} className="text-center">

              <div className="privacy-icon">
                <FaShieldAlt />
              </div>

              <h1>Privacy Policy</h1>

              <div className="privacy-divider"></div>

              <p>
                Your privacy is important to us. Learn how we handle your
                personal data.
              </p>

            </Col>
          </Row>
        </Container>
      </section>

      {/* Main Content */}
      <section className="privacy-content">
        <Container>
          <Row>
            <Col md={10} lg={9} className="mx-auto">

              {/* Information We Collect */}
              <Card className="privacy-card">
                <Card.Body>

                  <div className="privacy-card-header">
                    <div className="privacy-card-icon">
                      <FaUserShield />
                    </div>

                    <div>
                      <span className="privacy-number">01</span>
                      <h3>Information We Collect</h3>
                    </div>
                  </div>

                  <p>
                    We collect information when you register, fill out forms,
                    or interact with our website. This includes your name,
                    email, phone number, and browsing behavior.
                  </p>

                </Card.Body>
              </Card>

              {/* How We Use Your Information */}
              <Card className="privacy-card">
                <Card.Body>

                  <div className="privacy-card-header">
                    <div className="privacy-card-icon">
                      <FaShieldAlt />
                    </div>

                    <div>
                      <span className="privacy-number">02</span>
                      <h3>How We Use Your Information</h3>
                    </div>
                  </div>

                  <p>
                    Your information helps us personalize your experience,
                    improve our platform, and communicate with you effectively.
                  </p>

                </Card.Body>
              </Card>

              {/* How We Protect Your Information */}
              <Card className="privacy-card">
                <Card.Body>

                  <div className="privacy-card-header">
                    <div className="privacy-card-icon">
                      <FaLock />
                    </div>

                    <div>
                      <span className="privacy-number">03</span>
                      <h3>How We Protect Your Information</h3>
                    </div>
                  </div>

                  <p>
                    We use security measures like encryption, firewalls, and
                    secure servers to protect your data.
                  </p>

                </Card.Body>
              </Card>

              {/* Cookies */}
              <Card className="privacy-card">
                <Card.Body>

                  <div className="privacy-card-header">
                    <div className="privacy-card-icon">
                      <FaCookieBite />
                    </div>

                    <div>
                      <span className="privacy-number">04</span>
                      <h3>Cookies</h3>
                    </div>
                  </div>

                  <p>
                    We use cookies to enhance your browsing experience. You can
                    manage cookie preferences in your browser settings.
                  </p>

                </Card.Body>
              </Card>

              {/* Online Payment Transactions */}
              <Card className="privacy-card">
                <Card.Body>

                  <div className="privacy-card-header">
                    <div className="privacy-card-icon">
                      <FaCreditCard />
                    </div>

                    <div>
                      <span className="privacy-number">05</span>
                      <h3>Online Payment Transactions</h3>
                    </div>
                  </div>

                  <p>
                    All payments are processed securely through third-party
                    payment gateways. We do not store payment details.
                  </p>

                </Card.Body>
              </Card>

              {/* Changes to This Policy */}
              <Card className="privacy-card">
                <Card.Body>

                  <div className="privacy-card-header">
                    <div className="privacy-card-icon">
                      <FaSyncAlt />
                    </div>

                    <div>
                      <span className="privacy-number">06</span>
                      <h3>Changes to This Policy</h3>
                    </div>
                  </div>

                  <p>
                    We may update our privacy policy from time to time. Any
                    changes will be reflected on this page.
                  </p>

                </Card.Body>
              </Card>

              {/* Contact Us */}
              <Card className="privacy-contact-card">
                <Card.Body>

                  <div className="privacy-contact-icon">
                    <FaEnvelope />
                  </div>

                  <div>
                    <h3>Contact Us</h3>

                    <p>
                      If you have any questions, email us at{' '}
                      <a href="mailto:privacy@erwatoday.in">
                        privacy@erwatoday.in
                      </a>.
                    </p>
                  </div>

                </Card.Body>
              </Card>

            </Col>
          </Row>
        </Container>
      </section>

      <Footer />

      {/* Design Only */}
      <style>{`

        /* ===============================
           PAGE
        =============================== */

        .privacy-page {
          min-height: 100vh;
          background: #f5f7fb;
          color: #1f2937;
        }

        /* ===============================
           HERO
        =============================== */

        .privacy-hero {
          position: relative;
          overflow: hidden;
          padding: 70px 15px 85px;
          margin-top: 0;
          background:
            linear-gradient(
              135deg,
              #0f172a 0%,
              #172554 45%,
              #2563eb 100%
            );
          color: #ffffff;
        }

        .privacy-hero::before {
          content: "";
          position: absolute;
          width: 320px;
          height: 320px;
          border-radius: 50%;
          background: rgba(255,255,255,0.05);
          top: -170px;
          right: -80px;
        }

        .privacy-hero::after {
          content: "";
          position: absolute;
          width: 220px;
          height: 220px;
          border-radius: 50%;
          background: rgba(255,255,255,0.04);
          bottom: -140px;
          left: -80px;
        }

        .privacy-icon {
          position: relative;
          z-index: 2;
          width: 76px;
          height: 76px;
          margin: 0 auto 22px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 22px;

          background: rgba(255,255,255,0.12);
          border: 1px solid rgba(255,255,255,0.2);

          font-size: 31px;
          color: #ffffff;

          box-shadow:
            0 15px 40px rgba(0,0,0,0.15);
        }

        .privacy-hero h1 {
          position: relative;
          z-index: 2;

          margin: 0;

          font-size: 48px;
          font-weight: 800;
          letter-spacing: -1px;
        }

        .privacy-divider {
          position: relative;
          z-index: 2;

          width: 65px;
          height: 4px;

          margin: 20px auto;

          border-radius: 20px;

          background: #60a5fa;
        }

        .privacy-hero p {
          position: relative;
          z-index: 2;

          max-width: 650px;

          margin: 0 auto;

          color: rgba(255,255,255,0.82);

          font-size: 17px;
          line-height: 1.7;
        }

        /* ===============================
           CONTENT
        =============================== */

        .privacy-content {
          padding: 55px 15px 75px;
        }

        /* ===============================
           CARDS
        =============================== */

        .privacy-card {
          position: relative;

          margin-bottom: 18px;

          border: 1px solid #e6ebf2 !important;
          border-radius: 18px !important;

          background: #ffffff;

          box-shadow:
            0 5px 25px rgba(15,23,42,0.045);

          overflow: hidden;

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease,
            border-color 0.25s ease;
        }

        .privacy-card:hover {
          transform: translateY(-3px);

          border-color: #cbdafc !important;

          box-shadow:
            0 14px 35px rgba(37,99,235,0.09);
        }

        .privacy-card .card-body {
          padding: 28px 30px;
        }

        /* ===============================
           CARD HEADER
        =============================== */

        .privacy-card-header {
          display: flex;
          align-items: center;
          gap: 17px;

          margin-bottom: 16px;
        }

        .privacy-card-icon {
          flex-shrink: 0;

          width: 52px;
          height: 52px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 15px;

          background: #eff6ff;

          color: #2563eb;

          font-size: 21px;
        }

        .privacy-card-header h3 {
          margin: 0;

          color: #111827;

          font-size: 20px;
          font-weight: 750;
        }

        .privacy-number {
          display: block;

          margin-bottom: 2px;

          color: #94a3b8;

          font-size: 10px;
          font-weight: 800;

          letter-spacing: 1.5px;
        }

        /* ===============================
           TEXT
        =============================== */

        .privacy-card p {
          margin: 0;

          color: #64748b;

          font-size: 15px;

          line-height: 1.85;
        }

        /* ===============================
           CONTACT
        =============================== */

        .privacy-contact-card {
          margin-top: 28px;

          border: none !important;
          border-radius: 20px !important;

          background:
            linear-gradient(
              135deg,
              #eff6ff 0%,
              #ffffff 100%
            );

          box-shadow:
            0 10px 35px rgba(15,23,42,0.07);

          overflow: hidden;
        }

        .privacy-contact-card .card-body {
          display: flex;
          align-items: center;

          gap: 20px;

          padding: 30px;
        }

        .privacy-contact-icon {
          flex-shrink: 0;

          width: 58px;
          height: 58px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 17px;

          background: #2563eb;

          color: #ffffff;

          font-size: 22px;

          box-shadow:
            0 8px 20px rgba(37,99,235,0.2);
        }

        .privacy-contact-card h3 {
          margin: 0 0 7px;

          color: #111827;

          font-size: 22px;
          font-weight: 750;
        }

        .privacy-contact-card p {
          margin: 0;

          color: #64748b;

          font-size: 15px;

          line-height: 1.7;
        }

        .privacy-contact-card a {
          color: #2563eb;

          font-weight: 700;

          text-decoration: none;
        }

        .privacy-contact-card a:hover {
          color: #1d4ed8;

          text-decoration: underline;
        }

        /* ===============================
           MOBILE
        =============================== */

        @media (max-width: 767px) {

          .privacy-hero {
            padding: 50px 18px 65px;
          }

          .privacy-icon {
            width: 62px;
            height: 62px;

            border-radius: 18px;

            font-size: 25px;
          }

          .privacy-hero h1 {
            font-size: 36px;
          }

          .privacy-hero p {
            font-size: 15px;
          }

          .privacy-content {
            padding: 35px 12px 55px;
          }

          .privacy-card .card-body {
            padding: 22px;
          }

          .privacy-card-header {
            gap: 13px;
          }

          .privacy-card-icon {
            width: 44px;
            height: 44px;

            border-radius: 12px;

            font-size: 18px;
          }

          .privacy-card-header h3 {
            font-size: 17px;
          }

          .privacy-card p {
            font-size: 14px;

            line-height: 1.75;
          }

          .privacy-contact-card .card-body {
            align-items: flex-start;

            padding: 23px;

            gap: 14px;
          }

          .privacy-contact-icon {
            width: 45px;
            height: 45px;

            border-radius: 13px;

            font-size: 18px;
          }

          .privacy-contact-card h3 {
            font-size: 19px;
          }

          .privacy-contact-card p {
            font-size: 14px;
          }
        }

        @media (max-width: 480px) {

          .privacy-hero h1 {
            font-size: 32px;
          }

          .privacy-card .card-body {
            padding: 20px;
          }

          .privacy-card-header {
            align-items: flex-start;
          }

        }

      `}</style>
    </div>
  );
};

export default PrivacyPolicy;